export default __webpack_public_path__ + "static/media/RobotoMono400.336c829b.woff";